import { render, staticRenderFns } from "./stageItemProdsTab.vue?vue&type=template&id=48c01660"
import script from "./stageItemProdsTab.vue?vue&type=script&lang=js"
export * from "./stageItemProdsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports